import axiosInstance from "../axiosInstance";

export const asnService = {
  fetch: async (query, client, type) => {
    try {
      let api_query = `/asn?`;

      // api_query += `&$populate=supplier&$populate=purchase_order&$populate=client`;

      if (client) {
        api_query += `&client=${client}`;
      }

      if (query?.length) {
        api_query += `&${query}`;
      }
      if (type) {
        api_query += `&type=${type}`;
      }

      if (!api_query.includes("$sort")) {
        api_query += `&$sort[createdAt]=-1`;
      }

      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      console.error("Error fetching ASN:", error);
      throw error;
    }
  },

  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/asn", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      const response = await axiosInstance.patch(`/asn/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/asn/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchAsnTrail: async (id) => {
    try {
      const response = await axiosInstance.get(`/fetch-asn-trail/${id}`);
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  fetchById: async (id) => {
    try {
      const response = await axiosInstance.get(
        `/asn/${id}?$populate=purchase_order&$populate=supplier&$populate=sku_list.warehouse&$populate=sku_list.product`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchASNBySku: async (sku, skip = 0, limit = 15, search) => {
    try {
      let apiQuery = `/asn?$limit=${limit}&$skip=${skip}&sku_list.sku=${sku}&$sort[createdAt]=-1`;
      if (search) apiQuery += `&asn_no[$search]=${search}`;
      const response = await axiosInstance.get(apiQuery);
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  fetchPoNo: async (searchKey, client, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client) {
        query += `&client=${client}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }
      let response = await axiosInstance.get(`/fetch-po-no?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchPoOrderId: async (searchKey, client, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client) {
        query += `&client=${client}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }
      let response = await axiosInstance.get(`/fetch-po-orderId?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  reNotifySupplier: async (id) => {
    try {
      let response = await axiosInstance.get(`/po-notify-supplier/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  reNotifyWarehouse: async (id) => {
    try {
      let response = await axiosInstance.get(`/notify-and-create/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  reNotifySupplierDispatch: async (id) => {
    try {
      let response = await axiosInstance.get(
        `/po-notify-supplier-dispatch/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  notifyInventoryReady: async (id) => {
    try {
      let response = await axiosInstance.get(`/inventory-ready-notify/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
